/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { attachmentDtoSchema } from "./attachmentDtoSchema.ts";
import { z } from "zod/v4";

export const attachmentsDtoSchema = z.object({
  get items() {
    return z.array(attachmentDtoSchema).optional();
  },
});
